module.exports = __webpack_public_path__ + "img/star.eae35a06.svg";